import { defineComponent as _defineComponent } from 'vue'
import { fetchTagTemplate } from '@/apis/tag'
import store from '@/store'
import defaultTagData from '@/util/defaultTagData'
import { onMounted, ref, watchEffect } from 'vue'
import Vue from 'vue'

interface PropsType {
  title: string
  isLoading: boolean
  visible: boolean
  proLineName?: string
  print_color_tag?: boolean
}


export default /*#__PURE__*/_defineComponent({
  __name: 'm-sendModal',
  props: {
    title: null,
    isLoading: { type: Boolean },
    visible: { type: Boolean },
    proLineName: null,
    print_color_tag: { type: Boolean }
  },
  emits: ['onClose', 'onConfirm'],
  setup(__props: any, { emit: emits }) {

const props = __props as {
  title: string
  isLoading: boolean
  visible: boolean
  proLineName?: string
  print_color_tag?: boolean
}





const display = ref<boolean>(props.visible)
const template_list = ref<Array<any>>([
  { id: 0, name: '默认标签模板', data: defaultTagData },
])
const currentTagTempID = ref<number>(0)
const currentTagTemp = ref<any>({
  id: 0,
  name: '默认标签模板',
  data: defaultTagData,
})
const tagDocType = ref(['pdf'])
const tagDocTypes = ref([
  {
    label: '导出PDF' as const,
    value: 'pdf',
  },
  {
    label: '导出图片' as const,
    value: 'picture',
  },
])
let paibanImgType = ref(['picture'])

const handleOk = () => {
  emits('onConfirm', {
    tagDocType: tagDocType.value,
    currentTagTemp: currentTagTemp.value,
    currentTagTempID: currentTagTempID.value,
    template_list: template_list.value,
    paibanImgType: paibanImgType.value,
  })
}
const handleCancel = () => {
  display.value = false
  emits('onClose', display.value)
}
/** 获取模板列表 **/
const getTagTemplate = async () => {
  await Vue.prototype.$getByToken(
    '/get_tag_setting_list',
    { limit: 100, page: 1 },
    (res: any) => {
      if (res.status == 1 && res.data && res.data instanceof Array) {
        template_list.value = [
          { id: 0, name: '默认标签模板', data: defaultTagData },
          ...res.data,
        ]
        const defaultTemp = res.data.find((temp: any) => temp.is_default)
        store.state.tagTempList = template_list.value
        store.commit('setTempList', template_list.value)
        currentTagTempID.value = defaultTemp ? defaultTemp.id : 0
        currentTagTemp.value = defaultTemp ?? {
          id: 0,
          name: '默认标签模板',
          data: defaultTagData,
        }
      }
    }
  )
}

/** 选择应用的的标签模板 */
const handleSelectTemp = (item: any) => {
  currentTagTempID.value = item
  currentTagTemp.value = template_list.value.find((temp) => temp.id == item)
  // 更新默认模版
  fetchTagTemplate({ id: item })
}

watchEffect(() => {
  display.value = props.visible
})
onMounted(() => {
  getTagTemplate()
})

return { __sfc: true,emits, props, display, template_list, currentTagTempID, currentTagTemp, tagDocType, tagDocTypes, paibanImgType, handleOk, handleCancel, getTagTemplate, handleSelectTemp, store }
}

})